export default "__VITE_ASSET__DCFfp1XK__"